import { SectionBase, SectionButtonContent, SectionButtonContentV2, SectionLink } from '@models/section';

export type SubNavigationSection = SectionBase<34, { subNavigationSection: SubNavigationData }>;

export type SubNavigationData = SubNavigationV1 | SubNavigationV2;

export interface SubNavigationV1 {
    version: SubNavigationVersion.StickyLinksAndButtons | undefined;
    links: SectionLink[];
    buttons: SectionButtonContent[];
}

export interface SubNavigationV2 {
    version: SubNavigationVersion.Buttons;
    buttons: SectionButtonContentV2[];
}

export enum SubNavigationVersion {
    StickyLinksAndButtons = 'StickyLinksAndButtons',
    Buttons = 'Buttons',
}
